import type { CSSProperties } from "react";

interface WaveVisualProps {
  active: boolean;
  intensity: number;
}

export default function WaveVisual({ active, intensity }: WaveVisualProps) {
  const bars = Array.from({ length: 24 });
  const speed = (1.8 - (intensity / 100) * 1.0).toFixed(2);
  const amp = (0.45 + (intensity / 100) * 0.55).toFixed(2);

  return (
    <div className="my-1 flex h-12 items-end justify-center gap-[3px]">
      {bars.map((_, i) => (
        <span
          key={i}
          className={`wave-bar ${active ? "wave-active" : ""}`}
          style={
            {
              animationDelay: `${(i % 6) * 0.1}s`,
              animationDuration: `${speed}s`,
              opacity: active ? 1 : 0.32,
              "--wave-max": amp,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}